import IconAiChatSolid from '~/app/shared/components/Help/testIcons/IconAiChatSolid';
import IconAiStars from '~/app/shared/components/Help/testIcons/IconAiStars';
import IconEnvelopeSolid from '~/app/shared/components/Help/testIcons/IconEnvelopeSolid';
import IconPhoneSolid from '~/app/shared/components/Help/testIcons/IconPhoneSolid';
import IconQuestionMark from '~/app/shared/components/Help/testIcons/IconQuestionMark';

/**
 * FIXME: Icons not part of our standard icon set, for testing purposes. Once verified will be added to our icons.
 */
export const testIcons = {
    'ai-chat-solid': IconAiChatSolid,
    'ai-stars': IconAiStars,
    'envelope-solid': IconEnvelopeSolid,
    'phone-solid': IconPhoneSolid,
    'question-mark': IconQuestionMark,
};
